"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var languageUpdated_1 = require("./languageUpdated");
var languageAbandoned_1 = require("./languageAbandoned");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.LanguageEventNames.LanguageUpdated] = languageUpdated_1.languageUpdated,
    _a[analytics_layer_1.LanguageEventNames.LanguageAbandoned] = languageAbandoned_1.languageAbandoned,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
